'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _component = require('react-pure-render/component');

var _component2 = _interopRequireDefault(_component);

var _reduxSimple = require('redux-simple');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _routing = require('../../actions/routing');

var _Link = require('../Common/Link');

var _Link2 = _interopRequireDefault(_Link);

var _ProjectsListItemEdit = require('./ProjectsListItemEdit');

var _ProjectsListItemEdit2 = _interopRequireDefault(_ProjectsListItemEdit);

var _projectPermissions = require('./projectPermissions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* injects from baggage-loader */
var styles = require('./ProjectsListItem.pcss');

var getState = function getState(state) {
  return {
    authorizedUser: state.user.authorizedUser,
    currentProjectId: state.routing.params.projectId
  };
};

var ProjectListItem = (_dec = (0, _reduxSimple.connect)(getState), _dec(_class = (_temp = _class2 = function (_Component) {
  _inherits(ProjectListItem, _Component);

  function ProjectListItem() {
    _classCallCheck(this, ProjectListItem);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ProjectListItem).call(this));

    _this.state = {
      editing: false
    };
    return _this;
  }

  _createClass(ProjectListItem, [{
    key: 'isProjectForeign',
    value: function isProjectForeign() {
      var _props = this.props;
      var authorizedUser = _props.authorizedUser;
      var project = _props.project;


      if (!authorizedUser) return true;
      if (!project) return true;

      return authorizedUser.id !== project.owner;
    }
  }, {
    key: 'openEdit',
    value: function openEdit(e) {
      var _props2 = this.props;
      var currentProjectId = _props2.currentProjectId;
      var project = _props2.project;

      if (!this.isProjectForeign() && currentProjectId === project.id) {
        e.preventDefault();
        if (!this.state.editing) {
          this.setState({ editing: true });
        }
      }
    }
  }, {
    key: 'closeEdit',
    value: function closeEdit() {
      this.setState({ editing: false });
    }
  }, {
    key: 'getJalan',
    value: function getJalan() {
      var project = this.props.project;
      var owner = project.owner;
      var id = project.id;


      return (0, _routing.previewProject)(owner, id);
    }
  }, {
    key: 'getContent',
    value: function getContent() {
      var _props3 = this.props;
      var project = _props3.project;
      var currentProjectId = _props3.currentProjectId;
      var authorizedUser = _props3.authorizedUser;
      var editing = this.state.editing;


      var className = (0, _classnames2.default)(styles.project, !this.isProjectForeign() && currentProjectId === project.id ? styles.editableName : styles.nonEditableName, editing && styles.editing);

      var permissionIcon = !this.isProjectForeign() ? (0, _projectPermissions.getPermissionIcon)((0, _projectPermissions.getPermission)(project, authorizedUser.publicProjects)) : null;

      return _react2.default.createElement(
        'div',
        { className: className, onClick: this.openEdit.bind(this) },
        !editing && _react2.default.createElement(
          'span',
          { className: styles.projectName },
          project.name
        ),
        !editing && permissionIcon && _react2.default.createElement(
          'span',
          { className: styles.permissionIcon },
          permissionIcon
        ),
        editing && _react2.default.createElement(_ProjectsListItemEdit2.default, { project: project, afterEdit: this.closeEdit.bind(this) }),
        _react2.default.createElement(
          'span',
          { className: styles.nodesAmount },
          _lodash2.default.size(project.nodes)
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.state.editing) {
        var linkRoute = this.getJalan();

        return _react2.default.createElement(
          _Link2.default,
          { className: styles.root, jalan: linkRoute },
          this.getContent()
        );
      }

      return _react2.default.createElement(
        'div',
        { className: styles.root },
        this.getContent()
      );
    }
  }]);

  return ProjectListItem;
}(_component2.default), _class2.propTypes = {
  authorizedUser: _react.PropTypes.object,
  project: _react.PropTypes.object.isRequired,
  currentProjectId: _react.PropTypes.string
}, _temp)) || _class);
exports.default = ProjectListItem;


//////////////////
// WEBPACK FOOTER
// ./app/components/Projects/ProjectsListItem.js
// module id = 221
// module chunks = 1